<template>
  <div class="wrapper" :class="'wrapper-' + $store.getters.platform">

    <Loader v-if="waiting" style="z-index: 1;"></Loader>
    <div v-else>
      <router-view :key="$route.fullPath" />

      <div style="padding-top: 47px; padding-bottom: 47px;">

        <div id="search-form" class="row" style="padding: 1rem">
          <form ref="form" class="col s12 offset-m2 m8" autocomplete="off" onsubmit="return false;">
            <input ref="search" id="search-text" class="focusable" type="text" required v-model="text" v-on:keyup.enter="search" data-sn-right="">

          </form>
          <a id="search-button" v-on:click="search" v-on:keyup.enter="search" class="waves-effect waves-light btn-large focusable" tabindex="-1">
              <icon name="search" class="center-icon"></icon>
          </a>

        </div>

        <div v-if="results.length" style="overflow: hidden;">
          <app-list
            :options="{
              id: 'search-list',
              type: 'search-card-contents',
              title: title,
              items: results,
              route: 'search-content-detail',
              wrapper: $el
            }"
            @setLastFocused="setLastFocused($event)"
          />
        </div>
        <div v-else class="no-results"> <span>{{title}}</span> </div>
      </div>

      <div id="back-browser-root" ref="back" class="back-browser fadein-browser"
      @click="back" v-if="$store.getters.platform === 'browser'" v-show="$route.name !== 'search'">
        <icon name="arrow-left"></icon>
      </div>

    </div>
  </div>
</template>

<script>
import SpatialNavigation from 'js-spatial-navigation'
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'Search',
  components: { Loader, 'app-list': List },
  data () {
    return {
      text: '',
      results: [],
      lastFocused: null,
      waiting: false,
      setInterval: false,
      time: 0,
      title: '',
      lat: 0,
      lon: 0
    }
  },
  watch: {
    // al volver de otra ruta hacemos focus sobre la última lista seleccionada
    $route: function () {
      if (this.$route.name === 'search') {
        SpatialNavigation.focus(this.lastFocused)
        SpatialNavigation.resume()
      }
    }
  },
  created: function () {
    // plataforma
    this.restrict = navigator.userAgent.match(/Tizen/i) ? 'self-first' : 'self-only'

    // metas
    // document.title = this.$i18n.t('MENU.SEARCH')
    // document.querySelector('meta[name="Description"]').setAttribute('content', this.$store.getters.getData.display_name)

    this.SN = SpatialNavigation.add({ selector: '#search-form .focusable', restrict: this.restrict, defaultElement: '#search-text', enterTo: 'default-element' })

    SpatialNavigation.makeFocusable(this.SN)
    SpatialNavigation.resume()

    const locale = localStorage.getItem('locale-demo')
    if (this.$store.getters.user) {
      this.locale = this.$store.getters.user.country2 ? this.$store.getters.user.country2.language.locale : this.$i18n.locale
    } else if (locale && this.$store.getters.getData.countries.length) {
      this.locale = locale
    } else {
      this.locale = this.$i18n.locale
    }

    this.getGeolocation()
  },
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-ime-done', this.search)
    Bus.$on('key-ime-cancel', () => { SpatialNavigation.focus() })
    Bus.$on('key-left', this.keyLeft)
    Bus.$on('key-right', this.keyRight)
    Bus.$on('key-up', this.keyUp)
    Bus.$on('key-down', this.keyDown)

    // back browser
    if (this.$store.getters.platform === 'browser') {
      this.setInterval = setInterval(() => {
        this.time = this.time + 1
        if (this.time >= 3 && this.$refs.back) {
          this.$refs.back.classList.remove('fadein-browser')
          this.$refs.back.classList.add('fadeout-browser')
        }
      }, 1000)

      this.$el.addEventListener('mousemove', () => {
        if (this.$refs.back) {
          this.$refs.back.classList.remove('fadeout-browser')
          this.$refs.back.classList.add('fadein-browser')
        }
        this.time = 0
      })
    }
  },
  methods: {
    getGeolocation () {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.lat = location.lat
        this.lon = location.lon
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.lat = position.coords.latitude
              this.lon = position.coords.longitude
            },
            () => {
              this.lat = 0
              this.lon = 0
            },
            options)
        }
      }
    },
    back: function () { this.$router.go(-1) },
    search: function () {
      // Busquedad
      if (!this.waiting && this.text.length) {
        this.results = []
        this.waiting = true
        SpatialNavigation.pause()
        contentsService.searchContent(this.text, this.lat, this.lon, this.locale).then(response => {
          this.waiting = false
          // SpatialNavigation.resume()
          this.results = response.data['results']
          this.title = this.results.length ? this.$i18n.t('SEARCH.TITLE_OK') : this.$i18n.t('SEARCH.TITLE_KO')
          setTimeout(() => { if (!this.results.length) { SpatialNavigation.focus(this.SN) } SpatialNavigation.resume() }, 0)
        }).catch(error => {
          this.waiting = false
          SpatialNavigation.resume()
          console.error(error)
        })
      }
    },
    setLastFocused (e) {
      this.lastFocused = e.id
    },
    keyBack () {
      if (this.$route.name === 'search') {
        this.$router.replace({name: 'content'})
      }
    },
    keyUp () {
      if (this.restrict !== 'self-first') {
        setTimeout(() => {
          if (document.activeElement.id === 'list-search-list') {
            SpatialNavigation.focus('#search-form .focusable')
          } else if (document.activeElement.id === 'search-text') {
            SpatialNavigation.focus()
          }
        }, 0)
      }
    },
    keyDown () {
      if (this.restrict !== 'self-first') {
        setTimeout(() => {
          if (document.activeElement.id === 'search-text') {
            SpatialNavigation.focus('#list-search-list')
          }
        }, 0)
      }
    },
    keyLeft () {
      if (this.restrict !== 'self-first') {
        if (this.$refs.search === document.activeElement) {
          setTimeout(() => {
            if (this.$refs.search.value.length >= 1) {
              let pos = this.$refs.search.selectionStart - 1
              if (pos >= 0) { this.$refs.search.setSelectionRange(pos, pos) }
            }
          }, 0)
        }
      }
    },
    keyRight () {
      if (this.restrict !== 'self-first') {
        if (document.activeElement.classList.contains('body')) {
          SpatialNavigation.focus('#search-button')
        } else if (this.$refs.search === document.activeElement) {
          setTimeout(() => {
            let len = this.$refs.search.value.length
            if (len >= 1) {
              let pos = this.$refs.search.selectionStart + 1
              if (pos <= len) {
                this.$refs.search.setSelectionRange(pos, pos)
              } else {
                SpatialNavigation.focus('#search-button')
              }
            }
          }, 0)
        }
      }
    }
  },
  beforeDestroy: function () {
    clearInterval(this.setInterval)
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-ime-done', this.search)
    Bus.$off('key-ime-cancel', () => { SpatialNavigation.focus() })
    Bus.$off('key-left', this.keyLeft)
    Bus.$off('key-right', this.keyRight)
    Bus.$off('key-up', this.keyUp)
    Bus.$off('key-down', this.keyDown)

    if (this.SN) SpatialNavigation.remove(this.SN)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.wrapper
  width: 100%
  min-height: calc(100vh - 75px);
  min-height: -o-calc(100vh - 75px); // opera
  min-height: -webkit-calc(100vh - 75px); // google, safari
  min-height: -moz-calc(100vh - 75px); // firefox

  form
    border-radius: .3em
    position: relative

    input
      height: 54px
      font-size: 1.3rem
      box-sizing: border-box
      padding: 1rem
      background: white
      opacity: 0.8

    input:focus
      opacity: 1

.center-icon
  font-size: 2.3rem
  display: inline-flex
  vertical-align: middle

.no-results
  width: 100vw
  text-align: center

  span
    font-size: 3rem
    color: white
    text-shadow: #000000 0.1em 0.1em 0.2em
</style>



// WEBPACK FOOTER //
// src/pages/search/Search.vue